import React, { useEffect, useState } from 'react'

// react router
import { Link } from 'react-router-dom';

// icons
import { FiChevronDown, FiChevronRight } from "react-icons/fi";

export default function SubMenuItem(props) {
    // props
    const {
        menuItem,
        isSubMenu,

        setMobileMenuVisibility
    } = props

    // states
    const [openedMenu, setOpenedMenu] = useState(null)

    // variables
    let multiLevelMenu = null

    // if the menu has sub items
    if (menuItem?.sub_categories?.length) {
        multiLevelMenu = (
            <div className="sub-menu">
                <ul className="list-unstyled mb-0">
                    {
                        menuItem?.sub_categories?.length && menuItem.sub_categories.map(item => (
                            <SubMenuItem
                                key={item.category_id}

                                menuItem={item}

                                isSubMenu={true}

                                setMobileMenuVisibility={setMobileMenuVisibility}
                            />
                        ))
                    }
                </ul>
            </div>
        )
    }

    // handle sub menu
    const handleSubMenu = (ev, catId) => {
        ev.stopPropagation()
        ev.preventDefault()

        if(openedMenu === catId) {
            setOpenedMenu("")
        } else {
            setOpenedMenu(catId)
        }

    }

    return (
        <React.Fragment>
            <li className={`menu-item ${(openedMenu === menuItem.category_id) ? "active" : ""}`}>
                <Link 
                    to={
                        menuItem?.sub_categories?.length ? 
                            isSubMenu ? 
                            `/shop/${menuItem.category_url}?id=${menuItem.category_id}` :
                            `/category/${menuItem.category_url}?id=${menuItem.category_id}`
                        : `/shop/${menuItem.category_url}?id=${menuItem.category_id}`
                    }
                    className='menu-link cursor-pointer text-decoration-none d-flex align-items-center' onClick={() => setMobileMenuVisibility(false)}>
                    <span className='me-1 media-body'>{menuItem.category_name}</span>
                    {
                        menuItem?.sub_categories?.length ? (
                            <>
                                {
                                    (openedMenu === menuItem.category_id) ? (
                                        <div className="btn d-flex align-items-center justify-content-center" onClick={ev => handleSubMenu(ev, menuItem.category_id)}>
                                            <FiChevronDown />
                                        </div>
                                    ) : (
                                        <div className="btn d-flex align-items-center justify-content-center" onClick={ev => handleSubMenu(ev, menuItem.category_id)}>
                                            <FiChevronRight />
                                        </div>
                                    )
                                }
                            </>
                        ) : null
                    }
                </Link>
                {/* multilevel menu */}
                {multiLevelMenu}
            </li>
        </React.Fragment>
    )
}
